<template>
  <div class='content-body tenant-settings'>
    <div>
      <el-form :inline='true' size='small' :model='dataForm' @keyup.enter.native='queryHandle'>
        <el-form-item label='定点申请编码:' label-width='110px'>
          <el-input size='small' v-model='dataForm.technicalCode' placeholder='定点申请编码' clearable></el-input>
        </el-form-item>
        <el-form-item label='定点申请名称:' label-width='110px'>
          <el-input size='small' v-model='dataForm.technicalName' placeholder='定点申请名称' clearable></el-input>
        </el-form-item>
        <el-form-item label='物料编码:' label-width='90px'>
          <el-input size='small' v-model='dataForm.partCode' placeholder='物料编码' clearable></el-input>
        </el-form-item>
        <el-form-item label='物料名称:' label-width='90px'>
          <el-input size='small' v-model='dataForm.partName' placeholder='物料名称' clearable></el-input>
        </el-form-item>
        <el-form-item label='采购工程师:' label-width='100px'>
          <el-input size='small' v-model='dataForm.purResponsor' placeholder='采购工程师' clearable></el-input>
        </el-form-item>
        <el-form-item label='询价状态:' label-width='90px'>
          <el-select size='small' v-model='dataForm.rfqStatus' placeholder='请选择' clearable filterable>
            <el-option v-for='item in rfqStatusOptions' :key='item.value' :label='item.label' :value='item.value'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='采购任务状态:' label-width='110px'>
          <el-select size='small' v-model='dataForm.taskStatus' placeholder='请选择' clearable filterable>
            <el-option v-for='item in taskStatusOptions' :key='item.value' :label='item.label' :value='item.value'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='项目选择:' label-width='90px'>
          <el-select size='small' v-model='dataForm.project' placeholder='请选择' clearable filterable>
            <el-option v-for='item in projectOptions' :key='item.value' :label='item.label' :value='item.value'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='采购组织:' label-width='90px'>
          <el-select size='small' v-model='dataForm.purOrgCode' placeholder='请选择' clearable filterable>
            <el-option v-for='item in purOrgOptions' :key='item.value' :label='item.label' :value='item.value'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='询价日期:' label-width='90px'>
          <el-date-picker size='small' v-model='dataForm.rfqDateRange' type='daterange' value-format='yyyy-MM-dd' range-separator='至' start-placeholder='开始日期' end-placeholder='结束日期'></el-date-picker>
        </el-form-item>
        <el-form-item class='fr'>
          <el-button size='small' @click='queryHandle()' icon='el-icon-search'>查询</el-button>
          <el-button size='small' plain type='primary' @click='exportPriceAgreementData()'>导出</el-button>
        </el-form-item>
      </el-form>
      <div v-loading='dataListLoading'>
        <el-table :data='dataList' row-key='id' size='mini' style='width: 100%;' border :height='tableHeight' empty-text='暂无数据' :header-cell-style="{background:'#f5f5f5'}">
          <el-table-column type='index' width='50' label='序号'>
            <template slot-scope='scope'>{{ scope.$index + 1 + (pageIndex - 1) * pageSize }}</template>
          </el-table-column>
          <el-table-column prop='technicalCode' header-align='center' align='center' label='定点申请编码' width='120' show-overflow-tooltip></el-table-column>
          <el-table-column prop='technicalName' header-align='center' align='center' label='定点申请名称' width='180' show-overflow-tooltip></el-table-column>
          <el-table-column prop='technicalStatus' header-align='center' align='center' label='定点申请状态' width='100'>
            <template slot-scope='scope'><span>{{ technicalStatusFormat(scope.row.technicalStatus) }}</span></template>
          </el-table-column>
          <el-table-column prop='purOrgCode' header-align='center' align='center' label='采购组织编码' width='120'></el-table-column>
          <el-table-column prop='project' header-align='center' align='center' label='项目' width='100' show-overflow-tooltip></el-table-column>
          <el-table-column prop='bidType' header-align='center' align='center' label='招标类型' width='80'></el-table-column>
          <el-table-column prop='partCode' header-align='center' align='center' label='零件号' width='120' show-overflow-tooltip></el-table-column>
          <el-table-column prop='partName' header-align='center' align='center' label='零件名称' width='150' show-overflow-tooltip></el-table-column>
          <el-table-column prop='devPublishTime' header-align='center' align='center' label='研发任务发布时间' width='150'>
            <template slot-scope='scope'><span>{{ emptyFmt(scope.row.devPublishTime) }}</span></template>
          </el-table-column>
          <el-table-column prop='taskAssignTime' header-align='center' align='center' label='任务分配时间' width='150'>
            <template slot-scope='scope'><span>{{ emptyFmt(scope.row.taskAssignTime) }}</span></template>
          </el-table-column>
          <el-table-column prop='taskCode' header-align='center' align='center' label='采购任务编码' width='150' show-overflow-tooltip></el-table-column>
          <el-table-column prop='taskStatus' header-align='center' align='center' label='采购任务状态' width='100'>
            <template slot-scope='scope'><span>{{ taskStatusFormat(scope.row.taskStatus) }}</span></template>
          </el-table-column>
          <el-table-column prop='purResponsor' header-align='center' align='center' label='采购负责人' width='100' show-overflow-tooltip></el-table-column>
          <el-table-column prop='rfqCode' header-align='center' align='center' label='询价单编码' width='120'></el-table-column>
          <el-table-column prop='rfqStatus' header-align='center' align='center' label='询价单状态' width='100'>
            <template slot-scope='scope'>
              <span :style="{color: rfqStatusColor(scope.row.rfqStatus)}">{{ rfqStatusFormat(scope.row.rfqStatus) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop='taskTimes' header-align='center' align='center' label='询价轮次' width='80'></el-table-column>
          <el-table-column prop='rfqDate' header-align='center' align='center' label='询价日期' width='140'>
            <template slot-scope='scope'><span>{{ emptyFmt(scope.row.rfqDate) }}</span></template>
          </el-table-column>
          <el-table-column prop='pricingCompleteTime' header-align='center' align='center' label='定价完成时间' width='140'>
            <template slot-scope='scope'><span>{{ emptyFmt(scope.row.pricingCompleteTime) }}</span></template>
          </el-table-column>
          <el-table-column prop='supplierNames' header-align='center' align='center' label='参与供应商名称' width='200' show-overflow-tooltip>
            <template slot-scope='scope'><span>{{ emptyFmt(scope.row.supplierNames) }}</span></template>
          </el-table-column>
          <el-table-column prop='supplierCount' header-align='center' align='center' label='参与供应商数' width='90'></el-table-column>
          <el-table-column prop='rfqAuditCode' header-align='center' align='center' label='审批单编码' width='120'></el-table-column>
          <el-table-column prop='rfqAuditStatus' header-align='center' align='center' label='审批单状态' width='100'></el-table-column>
          <el-table-column prop='priceAgreementCode' header-align='center' align='center' label='价格协议编码' width='120'></el-table-column>
          <el-table-column prop='priceAgreementStatus' header-align='center' align='center' label='价格协议状态' width='100'>
            <template slot-scope='scope'><span>{{ priceAgreementStatusFormat(scope.row.priceAgreementStatus) }}</span></template>
          </el-table-column>
          <el-table-column prop='contractCode' header-align='center' align='center' label='合同编码' width='120' show-overflow-tooltip></el-table-column>
          <el-table-column prop='contractName' header-align='center' align='center' label='合同名称' width='150' show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
      <el-pagination @size-change='sizeChangeHandle' @current-change='currentChangeHandle' :current-page='pageIndex' :page-sizes='[10, 20, 50]' :page-size='pageSize' :total='totalPage' layout='total, sizes, prev, pager, next, jumper'></el-pagination>
    </div>
  </div>
</template>

<script>
import { statusList, statusExport } from '@/controller/tech'
import { projectList } from '@/controller/project'
import { getPurchaseOrgList } from '@/controller/systemData'

export default {
  data() {
    return {
      documentClientHeight: document.documentElement['clientHeight'] - 250,
      dataForm: {
        technicalCode: '',
        technicalName: '',
        partCode: '',
        partName: '',
        purResponsor: '',
        rfqStatus: '',
        taskStatus: '',
        project: '',
        purOrgCode: '',
        rfqDateRange: []
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      rfqStatusOptions: [
        { value: '0', label: '草稿' },
        { value: '1', label: '待询价' },
        { value: '2', label: '询价中' },
        { value: '3', label: '已开标' },
        { value: '4', label: '待提交' },
        { value: '5', label: '已提交' },
        { value: '7', label: '定厂结束' },
        { value: '8', label: '拟定价格协议' },
        { value: '9', label: '定点议价' }
      ],
      taskStatusOptions: [
        { value: '0', label: '待分配' },
        { value: '6', label: '待发布' },
        { value: '1', label: '已发布' },
        { value: '2', label: '已接受' },
        { value: '5', label: '已退回' },
        { value: '8', label: '已废弃' }
      ],
      purOrgOptions: [],
      projectOptions: []
    }
  },
  computed: {
    tableHeight: {
      get() {
        return this.$store.state.common.documentClientHeight - 280
      }
    }
  },
  activated() {
    this.loadProjectOptions()
    this.loadPurOrgOptions()
    this.getDataList()
  },
  methods: {
    // 加载采购组织下拉选项
    loadPurOrgOptions() {
      getPurchaseOrgList({
        purchaseOrgCode: '',
        purchaseOrgName: ''
      }).then(data => {
        if (data && data.code === '00') {
          this.purOrgOptions = (data.body || []).map(item => ({
            value: item.purchaseOrgCode,
            label: item.purchaseOrgCode + (item.purchaseOrgName ? ' ' + item.purchaseOrgName : '')
          }))
        } else {
          this.purOrgOptions = []
        }
      }).catch((e) => {
        console.log(e)
      })
    },
    // 加载项目下拉选项
    loadProjectOptions() {
      projectList({
        pageNo: 1,
        pageSize: 1000,
        projectStatus: '1'
      }).then(data => {
        if (data && data.code === '00') {
          this.projectOptions = (data.body.records || []).map(item => ({
            value: item.projectCode,
            label: item.projectCode + (item.projectName ? ' ' + item.projectName : '')
          }))
        } else {
          this.projectOptions = []
        }
      }).catch((e) => {
        console.log(e)
      })
    },
    // 定点申请状态
    technicalStatusFormat(value) {
      const map = { '0': '新建', '1': '发布', '2': '已作废' }
      return map[value] || value
    },
    // 采购任务状态
    taskStatusFormat(value) {
      const map = {
        '0': '待分配', '6': '待发布', '1': '已发布',
        '2': '已接受', '5': '已退回', '8': '已废弃'
      }
      return map[value] || value
    },
    // 询价单状态-文本
    rfqStatusFormat(value) {
      const map = {
        '0': '草稿', '1': '待询价', '2': '询价中', '3': '已开标',
        '4': '待提交', '5': '已提交', '6a': '审批通过', '6b': '驳回',
        '7': '定厂结束', '8': '拟定价格协议', '9': '定点议价'
      }
      return map[value] || value
    },
    // 询价单状态-颜色
    rfqStatusColor(value) {
      const map = {
        '0': '#8c8c8c', '1': '#faad14', '2': '#1890ff', '3': '#722ed1',
        '4': '#faad14', '5': '#1890ff', '6a': '#52c41a', '6b': '#f5222d',
        '7': '#52c41a', '8': '#13c2c2', '9': '#13c2c2'
      }
      return map[value] || '#8c8c8c'
    },
    // 价格协议状态
    priceAgreementStatusFormat(value) {
      const map = {
        '提交价格协议': '草稿', '供应商管理员审批': '已提交',
        '流程结束': '审批通过', '已同步': '已同步'
      }
      return map[value] || value
    },
    // 空值统一显示 "-"
    emptyFmt(value) {
      if (value === null || value === undefined || value === '') return '-'
      return value
    },
    // 构造查询参数（含日期范围拆分）
    buildQueryParams() {
      const params = {
        technicalCode: this.dataForm.technicalCode,
        technicalName: this.dataForm.technicalName,
        partCode: this.dataForm.partCode,
        partName: this.dataForm.partName,
        purResponsor: this.dataForm.purResponsor,
        rfqStatus: this.dataForm.rfqStatus,
        taskStatus: this.dataForm.taskStatus,
        project: this.dataForm.project,
        purOrgCode: this.dataForm.purOrgCode
      }
      const range = this.dataForm.rfqDateRange || []
      if (range.length === 2) {
        params.rfqDateBegin = range[0]
        params.rfqDateEnd = range[1]
      }
      return params
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      statusList(Object.assign({
        pageNo: this.pageIndex,
        pageSize: this.pageSize
      }, this.buildQueryParams())).then(data => {
        if (data && data.code === '00') {
          this.dataList = data.body.records
          this.totalPage = data.body.total
        } else {
          this.dataList = []
          this.totalPage = 0
        }
      }).catch((e) => {
        console.log(e)
      }).finally(() => {
        this.dataListLoading = false
      })
    },
    // 查询按钮
    queryHandle() {
      this.pageIndex = 1
      this.getDataList()
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 查询条件导出
    exportPriceAgreementData() {
      statusExport(this.buildQueryParams()).then((data) => {
        if (data && data.code == '00') {
          this.readAsBinaryString(data.body)
        } else {
          this.$message.error(data.msg)
        }
      }).catch((e) => {
        console.log(e)
      })
    },
    readAsBinaryString(data) {
      const blob = this.str2Blob(data.content, 'application/vnd.ms-excel;charset=utf-8')
      const url = window.URL.createObjectURL(blob)
      let dom = document.createElement('a')
      dom.style.display = 'none'
      dom.href = url
      dom.setAttribute('download', decodeURI(data.fileName))
      document.body.appendChild(dom)
      dom.click()
    },
    str2Blob(str, mime) {
      var arr = str.split(',')
      var bstr = atob(arr[0]),
          n = bstr.length,
          u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    }
  }
}
</script>
